// extracted by mini-css-extract-plugin
module.exports = {"dataRetentionBanner":"data-retention-banner_dataRetentionBanner_2yp","hideWave":"data-retention-banner_hideWave_2R3"};